import { jsx as _jsx } from "react/jsx-runtime";
import TextField from "@mui/material/TextField";
import { useControlledTextEdit, useCsAttribute, } from "@plansoft-configuration-renderer/framework";
import { useAttributeInlineLabel } from "../../Attributes/useAttributeInlineLabel";
import { useAttributeLayout } from "../../layouts/AttributeLayoutContext";
import { useEditControlLayoutProps } from "./useEditControlLayoutProps";
import { useEditInputProps } from "./useEditInputProps";
/**
 * Text editable control
 * @returns
 */
export function TextEdit() {
    const { debounceDelay, updateBehavior, multiline, showReset } = useEditControlLayoutProps();
    const { value, handleChange, handleFocus, handleBlur, handleReset } = useControlledTextEdit({ debounceDelay, updateBehavior });
    const inputProps = useEditInputProps({ showReset, handleReset });
    const { fullWidth, variant, size, margin } = useAttributeLayout();
    const { labelText } = useAttributeInlineLabel();
    const attribute = useCsAttribute();
    const isDisabled = Boolean(!attribute.isAllowed);
    const isReadOnly = Boolean(attribute.isReadOnly);
    return (_jsx(TextField, { multiline: multiline, fullWidth: fullWidth, variant: variant, size: size, margin: margin, label: labelText, required: attribute.isRequired, disabled: isDisabled || isReadOnly, type: "text", value: value, onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange, slotProps: {
            input: inputProps,
        } }));
}
//# sourceMappingURL=Edit.TextEdit.js.map